module.exports = __webpack_public_path__ + "static/media/Subtract 4.44846dc6.png";